import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { hasPlanFeature } from '../utils/planAccess';

const getFallbackPath = (user) => {
    if (user?.role === 'superadmin') {
        return '/superadmin/dashboard';
    }

    if (user?.role === 'anbardar') {
        return hasPlanFeature(user?.tenant_plan, 'warehouse')
            ? '/warehouse/dashboard'
            : '/admin/menu';
    }

    if (user?.role === 'admin') {
        return '/admin/dashboard';
    }

    return '/waiter/tables';
};

const ProtectedRoute = ({ children, roles = [], feature = null, kassirFlag = null }) => {
    const { user, token } = useAuthStore();

    if (!token || !user) {
        return <Navigate to="/" replace />;
    }

    if (roles.length > 0 && !roles.includes(user.role)) {
        return <Navigate to={getFallbackPath(user)} replace />;
    }

    if (feature && !hasPlanFeature(user.tenant_plan, feature) && user.role !== 'superadmin') {
        return <Navigate to={getFallbackPath(user)} replace />;
    }

    // Kassir üçün əlavə tenant-flag tələbi (məs. anbar baxışı) — digər rollara aid deyil
    if (kassirFlag && user.role === 'kassir' && !user[kassirFlag]) {
        return <Navigate to={getFallbackPath(user)} replace />;
    }

    return children;
};

export default ProtectedRoute;
